module.exports = "/fonts/vendor/tinymce/skins/lightgray/tinymce-small.woff?7e0c88f02dcaf2f78c90b4dc7827b709";